/* global document: false */
import { ProcGenWrapperDom } from './proc_gen_wrapper_dom';
const DEFAULT_PROC_GEN_DOM = () => ({
    C: (isCreation, defineTextNode, defineElement, defineIfGroup, defineForLoop, defineSlot) => {
        defineSlot('');
    },
    B: Object.create(null),
});
export const DEFAULT_PROC_GEN_GROUP_DOM = () => DEFAULT_PROC_GEN_DOM;
export class GlassEaselTemplateDOM {
    constructor(behavior) {
        if (typeof behavior._$template !== 'object' && behavior._$template !== undefined) {
            throw new Error(`Component template of ${behavior.is} must be a valid compiled template (or "null" for default template).`);
        }
        else {
            const c = behavior._$template || {
                content: DEFAULT_PROC_GEN_GROUP_DOM,
            };
            this.genObjectGroupEnv = {
                list: c.groupList || Object.create(null),
                group: c.content,
            };
        }
        this.updateMode = '';
    }
    createInstance(comp) {
        return new GlassEaselTemplateDOMInstance(this, comp);
    }
}
export class GlassEaselTemplateDOMInstance {
    constructor(template, comp) {
        if (comp.getBackendMode() !== 3 /* BackendMode.Domlike */) {
            throw new Error(`Component template of ${comp.is} cannot be initialized since external rendering is only supported in Domlike backend currently.`);
        }
        const shadowRootElement = comp.getBackendElement();
        if (!shadowRootElement) {
            throw new Error(`Component template of ${comp.is} cannot be initialized as external components since no suitable backend element found.`);
        }
        this.comp = comp;
        this.shadowRoot = this;
        this.shadowRootElement = shadowRootElement;
        this.root = shadowRootElement;
        this.slot = shadowRootElement;
        this.template = template;
        const procGen = template.genObjectGroupEnv.group('') || DEFAULT_PROC_GEN_GROUP_DOM('');
        this.procGenWrapper = new ProcGenWrapperDom(this, procGen);
        this.idMap = Object.create(null);
        this.listeners = [];
    }
    initValues(data) {
        this.bindingMapGen = this.procGenWrapper.create(data);
        if (!this.bindingMapGen) {
            throw new Error('The component template does not support binding-map-update, so it cannot be used as external components.');
        }
        const shadowRoot = this.shadowRootElement;
        if (this.slot === shadowRoot && shadowRoot.childNodes.length > 0) {
            // if `<slot />` is forgot, add one at the end of the child list
            const slot = document.createElement('virtual');
            shadowRoot.appendChild(slot);
            this.slot = slot;
        }
    }
    getIdMap() {
        return this.idMap;
    }
    updateValues(data, changes) {
        const bindingMapGen = this.bindingMapGen;
        for (let i = 0; i < changes.length; i += 1) {
            const [path] = changes[i];
            this.procGenWrapper.bindingMapUpdate(path[0], data, bindingMapGen);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    setListener(elem, ev, listener) {
        const target = elem;
        if (target._$wxTmplEv) {
            target._$wxTmplEv[ev] = listener;
        }
        else {
            target._$wxTmplEv = { [ev]: listener };
        }
    }
    handleEvent(elem, event) {
        var _a;
        const target = elem;
        let cur = target;
        const root = this.shadowRootElement;
        const evName = event.getEventName();
        const bubbles = event.bubbles;
        for (;;) {
            const shadowedEvent = event.wrapShadowedEvent(target, null, cur);
            const f = (_a = cur._$wxTmplEv) === null || _a === void 0 ? void 0 : _a[evName];
            if (f) {
                const r = f.call(cur, shadowedEvent);
                if (r === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
            if (!bubbles || event.propagationStopped())
                break;
            if (cur === root)
                break;
            const next = cur.parentNode;
            if (next)
                cur = next;
            else
                break;
        }
    }
}
//# sourceMappingURL=native_rendering.js.map